// import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import MessageBubbleCard from "../cards/message/MessageBubbleCard";
import { LoadingDots } from "../loading/LoadingDots";
import { Loader } from "lucide-react";
import { useArtifactStore } from "@/stores/artifact-store";
// import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

type Props = {
    messages: any[];
    isThinking: boolean;
    isLoadingMessage: boolean;
    isFetchingNextPageMessage: boolean;
    newestMessageRef: any;
    fetchMoreTriggerRef: any;
    newUserMessage?: any;
    isSendingNewUserMessage?: boolean;
    streamedMessageId?: string;
    streamingAgent?: {
        origin: string;
        node: string;
    };
    streamingData?: string;
    isStreaming?: boolean;
    onEditMessage?: (messageId: string, newContent: string) => void;
};

const MessageList = ({
    messages,
    isThinking,
    isLoadingMessage,
    isFetchingNextPageMessage,
    newestMessageRef,
    fetchMoreTriggerRef,
    streamedMessageId,
    isStreaming,
    onEditMessage,
}: Props) => {
    const { isOpen } = useArtifactStore();

    return (
        <div className="flex h-full w-full flex-col-reverse items-center overflow-y-auto overflow-x-hidden pb-8">
            <div
                ref={newestMessageRef}
                className={cn(
                    "flex w-full max-w-xl flex-grow flex-col-reverse xl:max-w-xl 3xl:max-w-2xl 4xl:max-w-3xl",
                    isOpen && "max-w-sm xl:max-w-md 3xl:max-w-xl 4xl:max-w-2xl"
                )}
            >
                <div className="flex-grow"></div>
                {isThinking && (
                    <div className="flex min-h-[60px] items-start self-start px-3">
                        <LoadingDots color="bg-primary" />
                    </div>
                )}
                {isLoadingMessage ? (
                    <div className="flex min-h-[calc(100%-20px)] flex-grow items-center justify-center">
                        <Loader className="h-6 w-6 animate-spin" />
                    </div>
                ) : (
                    messages.map((message, index) => {
                        if (!message.content) return null;
                        return (
                            <MessageBubbleCard
                                key={index}
                                {...message}
                                isStreaming={isStreaming && streamedMessageId && message.id === streamedMessageId}
                                onEdit={onEditMessage}
                            />
                        );
                    })
                )}
                {isFetchingNextPageMessage && (
                    <div className="flex h-10 flex-grow items-center justify-center p-2">
                        <Loader className="h-6 w-6 animate-spin" />
                    </div>
                )}
                <div ref={fetchMoreTriggerRef} className="h-[1px]" aria-hidden />
            </div>
        </div>
    );
};

export default MessageList;
